import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import fetch, { update } from '../../../Api/definitionCourseDepartment';

/**
 * Carga los cursos del departamento y guarda cuáles quedan asignados.
 *
 * `coursesByEnterprise` no se define aquí: son los que el empleado ya arrastra
 * por ser de la empresa, y viajan solo para mostrarlos.
 *
 * @param {{departmentId: string}} params - Departamento en edición.
 * @param {Function} setIsLoading - Apaga el indicador de carga de la tabla.
 */
const useCourse = ({ departmentId }, setIsLoading) => {
  const history = useHistory();
  const [courses, setCourses] = useState([]);
  const [coursesByEnterprise, setCoursesByEnterprise] = useState([]);
  const [defaultSelectedIds, setDefaultSelectedIds] = useState([]);
  const [terminals, setTerminals] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let isMounted = true;

    fetch(departmentId).then(data => {
      if (!isMounted) return;

      setCourses(data.courseByDepartment);
      setCoursesByEnterprise(data.courseByEnterprise);
      setCategories(data.categories);
      setTerminals(data.terminals);
      setDefaultSelectedIds(data.courseByDepartment.filter(course => course.isChecked).map(course => course.id));
      setIsLoading(false);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  /**
   * Guarda la diferencia y vuelve al hub, que anuncia el éxito.
   *
   * @param {{id: string, value: boolean}[]} courseData - Cursos a marcar o desmarcar.
   */
  const saveCourses = courseData => {
    update(courseData, departmentId)
      .then(() => {
        history.push({
          pathname: '/definicion',
          state: {
            update: true,
          },
        });
      })
      .catch(err => err);
  };

  return {
    courses,
    terminals,
    categories,
    saveCourses,
    coursesByEnterprise,
    defaultSelectedIds,
  };
};

export default useCourse;
